// Prislinjene på et tekstiltrykk i nettleseren: samme regler som src/lib/trykkLinjer.js på serveren.
// Lagrede prislinjer brukes; eldre trykk med arbeid/deler gjøres om til linjer (produkter først,
// så arbeid), som så lagres som prislinjer første gang de endres.
// Hver linje er arbeid eller produkt (type). «Trykket er betalt» gjelder arbeidet og «Tøyet er
// betalt» produktene; resten er det kunden skal betale i kassa (arbeidsseddelen).
import { regnPaNytt, linjeTall } from '../tilbud/kalkyle';

const tall = (v) => {
  const n = Number(String(v ?? '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export function linjerForTrykk(trykk) {
  if (Array.isArray(trykk?.prislinjer)) {
    return trykk.prislinjer.map((l) => ({ ...l, rabattKr: l.rabattKr ?? l.totalRabattKr ?? 0 }));
  }
  const produkter = (trykk?.deler || []).map((d) => regnPaNytt({
    artikkel: [d.brand, d.product].filter(Boolean).join(' ') || 'Produkt',
    pris: Number(d.price) || 0,
    antall: Math.max(1, parseInt(d.numberof, 10) || 1),
    rabatt: Number(d.discount) || 0,
    rabattKr: 0,
    type: 'produkt',
    ...(d.ean ? { ean: String(d.ean) } : {}),
  }));
  const arbeid = (trykk?.arbeid || []).map((a) => ({
    artikkel: a.title || 'Trykk', pris: Number(a.price) || 0, antall: 1, rabatt: 0, rabattKr: 0, type: 'arbeid',
  }));
  return [...produkter, ...arbeid];
}

// Linjer lagret før type fantes: varer fra produktlisten (produkt-ID eller EAN) er produkter.
export const linjeType = (l) => l.type || (l.produktId || l.variantId || l.ean ? 'produkt' : 'arbeid');

// Er linjen betalt? betaling: { toyBetalt, trykkBetalt } fra trykket.
export const linjeBetalt = (l, betaling) => (linjeType(l) === 'arbeid' ? !!betaling?.trykkBetalt : !!betaling?.toyBetalt);

// Totalt, hva som er betalt og hva som gjenstår.
export function betalingssum(linjer, betaling) {
  let total = 0;
  let betalt = 0;
  linjer.forEach((l) => {
    const t = linjeTall(l).total;
    total += t;
    if (linjeBetalt(l, betaling)) betalt += t;
  });
  return { total, betalt, aBetale: total - betalt };
}

// Det som avgjør om linjene er endret (eller om pristilbudet har andre linjer enn trykket).
export const linjeNokkel = (l) => [
  String(l.artikkel || '').trim(),
  tall(l.pris),
  Math.max(1, Math.round(tall(l.antall) || 1)),
  Math.round(tall(l.rabattKr ?? l.totalRabattKr)),
];
